import Vue from 'vue'
import Vuex from 'vuex'
import * as ACTIONS from '../actions'
import * as MUTATIONS from '../mutations'
import API from '../../services/api'
import URL from 'url'

Vue.use(Vuex)

export default {
	state: {
		list: [],
		count: 0,
	},
	mutations: {
		[MUTATIONS.POST_OCR_LOGO.LIST](state, list) {
			state.list = list
		},
		[MUTATIONS.POST_OCR_LOGO.ADD_LIST](state, list) {
			const l = [...state.list].concat(list)
			state.list = l
		},
		[MUTATIONS.POST_OCR_LOGO.COUNT](state, count) {
			state.count = count
		},
	},
	actions: {
		[ACTIONS.POST_OCR_LOGO.BY_ID]({ commit, dispatch, state }, { id, filter = {} }) {
			return API.POST_OCR_LOGO.BY_ID(id, filter).then(res => {
				// eslint-disable-next-line node/no-deprecated-api
				res.image = URL.resolve('https://storage.googleapis.com', res.image)
				commit(MUTATIONS.POST_OCR_LOGO.CURRENT, res)
				return res
			})
		},
		[ACTIONS.POST_OCR_LOGO.BY_DETAIL_ID](
			{ commit, dispatch, state },
			{ filter, append = false },
		) {
			return API.POST_OCR_LOGO.LIST(filter).then(res => {
				res.forEach(post => {
					if (post.image) {
						// eslint-disable-next-line node/no-deprecated-api
						post.image = URL.resolve(
							'https://storage.googleapis.com',
							post.image,
						)
					}
				})

				if (append) {
					commit(MUTATIONS.POST_OCR_LOGO.ADD_LIST, res)
				} else {
					commit(MUTATIONS.POST_OCR_LOGO.LIST, res)
				}

				return res
			})
		},
		[ACTIONS.POST_OCR_LOGO.COUNT]({ commit, dispatch, state }, filter = {}) {
			return API.POST_OCR_LOGO.COUNT(filter).then(res => {
				commit(MUTATIONS.POST_OCR_LOGO.COUNT, res.count)
				return res.count
			})
		},
	},

	getters: {
		getPostsOcr: state => state.list,
		getPostsOcrTotalCount: state => state.count,
	},
}
